import { X } from "lucide-react";
import type { ComponentPropsWithRef } from "react";

type Props = Omit<ComponentPropsWithRef<"button">, "children"> & {
  label: string;
  iconSize?: number;
};

export function CloseIconButton({
  label,
  iconSize = 18,
  className = "",
  ...props
}: Props) {
  return (
    <button
      {...props}
      type="button"
      className={`ui-close-icon-button ${className}`.trim()}
      aria-label={label}
    >
      <X size={iconSize} aria-hidden="true" />
    </button>
  );
}
